import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {  Box, Typography, Grid, CircularProgress, Divider, FormLabel } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { SaveRounded, ClearRounded } from "@mui/icons-material";
import { READ_TERM_CONDITIONS, UPDATE_TERM_CONDITIONS } from '../../../services/apiRoutes';
import CustomButton from '../../common/CustomButton';
 import CustomStyle from '../../common/CustomStyle';
import CustomAutocomplete from '../../common/CustomAutoComplete';
import { EditorState, convertFromHTML, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import draftToHtml from 'draftjs-to-html';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { renderHtmlContent } from "../../../services/apiServices";
import { t } from '../../../constants/translationHelper';


const ValidationSchema = Yup.object().shape({
    voucherName: Yup.string().required('Voucher Name is required'),
});

const UpdateTermConditions = ({ handleClose, id, setMessage, fetchData, voucher }) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (state) => {
        setEditorState(state);
    };
    const convertToHTMLContent = () => {
        const contentState = editorState.getCurrentContent();
        // const htmlContent = stateToHTML(contentState);
        const htmlContent = draftToHtml(convertToRaw(contentState));
        return htmlContent;
    };

    useEffect(() => {
        if (!id) return;

        const fetchData = async () => {
            try {
                const accessToken = sessionStorage.getItem('accessToken');
                const response = await axios.get(READ_TERM_CONDITIONS(id), {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                setData(response.data.termCondition);
                const htmlContent = response.data.termCondition.termConditions || '';
                const contentState = htmlContent ? convertFromHTML(htmlContent) : null;
                setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentState.contentBlocks)));
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (loading) return <CircularProgress />;
    if (error) return <p>Error: {error}</p>;

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const response = await axios.put(UPDATE_TERM_CONDITIONS(id), {
                ...values,
                termConditions: convertToHTMLContent(),
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "term Conditions updated successfully",
                    type: "success",
                });
                fetchData();
                setTimeout(() => {
                    handleClose();
                },);
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={{
                    voucherName: parseInt(data?.voucherName || ''),
                    termConditions: data?.termConditions || '',
                }}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values }) => (
                    <Form>
                        <Grid container spacing={1} style={CustomStyle.container}>
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                    {t("Update Term Conditions")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} md={8} style={CustomStyle.buttonContainer}>
                                <Box style={CustomStyle.buttonBox}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={2} sx={{ px: "5%", paddingTop: "5px" }}>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <CustomAutocomplete
                                    options={voucher}
                                    fieldLabel="Select Voucher"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={voucher.find((option) => option.id === values.voucherName) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('voucherName', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Voucher"
                                    error={touched.voucherName && !!errors.voucherName}
                                    helperText={touched.voucherName && errors.voucherName}
                                    readOnly={true}
                                    sx={CustomStyle.readOnly}
                                />

                            </Grid>


                            <Grid item xs={12} md={12}>
                                <FormLabel sx={{ paddingBottom: "10px" }} style={{
                                    color: "#212529",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textTransform: "capitalize"
                                }}>
                                    {t("term Conditions")}
                                </FormLabel>
                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    wrapperClassName="demo-wrapper"
                                    editorClassName="demo-editor"
                                    wrapperStyle={{
                                        border: '1px solid #CED4DA', borderRadius: '4px',
                                    }}
                                    editorStyle={{ padding: "10px" }}
                                />
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};


export default UpdateTermConditions;
